import React from "react";
import { Card, CardContent } from "../ui/card";

export function Section({ title, hint, children, testId, actions }) {
  return (
    <Card className="ds-card border-erf-borderCream" data-testid={testId}>
      <CardContent className="p-4 sm:p-5 space-y-3">
        <div className="ds-card-header">
          <div className="ds-card-header__title">
            <h2 className="font-display font-semibold text-erf-dark text-base md:text-lg">{title}</h2>
            {hint && <p className="text-xs font-nav text-erf-dark/70 mt-0.5 ds-text-safe">{hint}</p>}
          </div>
          {actions && <div className="ds-card-header__chip">{actions}</div>}
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
